const AVATAR_COLORS = [
  '#25272C',
  '#FFCC00',
  '#3FDDDD',
  '#AF52DE',
  '#D22C54',
  '#3AC090',
];

export const getTeamAccountAvatarColor = (index: number) =>
  AVATAR_COLORS[index] || AVATAR_COLORS[index % AVATAR_COLORS.length];
